module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei7.svg";